// src/component/Account/skeletons.jsx
export const LineSkel = () => (
  <div className="skel skel-line" aria-hidden />
);

export const AvatarSkel = () => (
  <div className="skel skel-avatar" aria-hidden />
);
